export const signUpFormDefaultValues = {
  firstName: "",
  lastName: "",
  mobile: "",
  email: "",
};
